export function createNumberArray(
  start: number,
  end: number,
  step = 1
): number[] {
  return Array.from(
    { length: Math.floor((end - start) / step) + 1 },
    (_, i) => start + i * step
  );
}
